import { Observable } from 'rxjs';
import { BsModalService } from 'ngx-bootstrap/modal';
import { CustomRespondConfirmation } from '../objects/DialogObject';
import { CustomPopupComponent } from '../custom-popup/custom-popup.component';
import * as i0 from "@angular/core";
import * as i1 from "ngx-bootstrap/modal";
import * as i2 from "../objects/DialogObject";
var CustomPopupService = /** @class */ (function () {
    function CustomPopupService(bsModalService, customRespondConfirmation) {
        this.bsModalService = bsModalService;
        this.customRespondConfirmation = customRespondConfirmation;
    }
    CustomPopupService.prototype.confirm = function (title, content, inputText, options, selectedItem) {
        var initialState = {
            title: title,
            content: content,
            options: options,
            inputText: inputText,
            selectedItem: selectedItem
        };
        if (this.bsModalService.getModalsCount() > 0) {
            document.querySelectorAll('.modal.fade').item(this.bsModalService.getModalsCount() - 1).classList.remove('show');
        }
        this.bsModalRef = this.bsModalService.show(CustomPopupComponent, { class: "modal-dialog-centered modal-custom", ignoreBackdropClick: true, keyboard: false, initialState: initialState });
        return new Observable(this.getConfirmSubscriber());
    };
    CustomPopupService.prototype.getConfirmSubscriber = function () {
        var _this = this;
        return function (observer) {
            var subscription = _this.bsModalService.onHidden.subscribe(function (reason) {
                document.querySelectorAll('.modal-backdrop').item(0).classList.remove('layer');
                if (_this.bsModalService.getModalsCount() > 0) {
                    // if (this.bsModalRef.content.answer == 'OK'){
                    //   for (let i = 1; i <= this.bsModalService.getModalsCount(); i++) {
                    //     this.bsModalService.hide(i);
                    //   }
                    //   document.body.classList.remove('modal-open');
                    // }
                    // else {
                    document.querySelectorAll('.modal.fade').item(_this.bsModalService.getModalsCount() - 1).classList.add('show');
                    // }
                }
                _this.customRespondConfirmation.respondObject = _this.bsModalRef.content.respondObject;
                _this.customRespondConfirmation.answer = _this.bsModalRef.content.answer;
                observer.next(_this.customRespondConfirmation);
                observer.complete();
            });
            return {
                unsubscribe: function () {
                    subscription.unsubscribe();
                }
            };
        };
    };
    CustomPopupService.ngInjectableDef = i0.defineInjectable({ factory: function CustomPopupService_Factory() { return new CustomPopupService(i0.inject(i1.BsModalService), i0.inject(i2.CustomRespondConfirmation)); }, token: CustomPopupService, providedIn: "root" });
    return CustomPopupService;
}());
export { CustomPopupService };
